import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileFormComponent } from './profile-form/profile-form.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { AccountSettingGuard } from './account-settings/account-settings.guard';

const routes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: 'form'
  },
  {
    path: 'form',
    component: ProfileFormComponent
  },
  // {
  //   path: 'settings',
  //   component: AccountSettingsComponent
  // },
  { 
    path: 'settings', 
    component: AccountSettingsComponent, 
    canDeactivate: [AccountSettingGuard]  // Apply the guard here
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
